import { Card, CardBody, Col, Row } from 'reactstrap'
import { ProgressBarsStriped } from '../../../../Utils/Constants'
import { progressStripData, progressStripList } from '../../../../Data/Ui-Kits/Progress/Progress'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'
import { ProgressBar } from '../../../../AbstractElements'

const ProgressBarsStripedCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={ProgressBarsStriped} span={progressStripData} />
        <CardBody className="progress-showcase">
          <Row>
            <Col>
              <ProgressBar color="primary" striped value="10" />
              {progressStripList.map(({ color, value }, index) => (
                <ProgressBar color={color} striped value={value} key={index} />
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ProgressBarsStripedCart